import { CSSResultGroup, TemplateResult, html } from 'lit';
import {
  OutlineElement,
  SlotsController,
  LightDomStyles,
} from '@phase2/outline-core';
import { customElement } from 'lit/decorators.js';
import componentStyles from './outline-profile-page-wrapper.css.lit';

import placeholderImage from '../../assets/images/placeholder-image.png';

import '../outline-grid-baseline/outline-grid-baseline';
import '../outline-column-baseline/outline-column-baseline';

/**
 * The Profile Page Wrapper component
 * @element outline-profile-page-wrappe
 * @slot image - Image slot
 * @slot name - Person's name
 * @slot title - Job title
 * @slot department - Department
 * @slot detail-contact - Contact information (office/mobile phone, email)
 * @slot detail-location - Office location/name
 * @slot page-content - Page body/content
 */
@customElement('outline-profile-page-wrapper')
export class OutlineProfilePageWrapper extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  slots = new SlotsController(this);

  lightDomStyles = new LightDomStyles(
    this,
    componentStyles,
    this.tagName.toLowerCase()
  );

  render(): TemplateResult {
    return html`
      <section class="profile-page-wrapper">
        <outline-grid-baseline content-max-width="none" x-padding="false">
          <outline-column-baseline col-span-lg="4">
            ${this.slots.exist('image')
              ? html`<slot name="image"></slot>`
              : html`
                  <div class="image-placeholder">
                    <img src="${placeholderImage}" alt="" />
                  </div>
                `}
          </outline-column-baseline>

          <outline-column-baseline col-span-lg="8">
            ${this.slots.conditionalSlot('name', false)}
            <div class="personal-info-wrapper">
              ${this.slots.conditionalSlot('title', false)}
              ${this.slots.conditionalSlot('department', false)}
            </div>

            <div class="details-wrapper">
              ${this.slots.conditionalSlot('detail-contact', false)}
              ${this.slots.conditionalSlot('detail-location', false)}
            </div>
          </outline-column-baseline>
        </outline-grid-baseline>
      </section>
    `;
  }
}
